import { ContextFormFieldCheckbox } from '@bambi/component-library/src/components/forms/context/ContextFormFieldCheckbox';

import { SettingsRowHeader } from './components/SettingsRowHeader';

export default function PermissionSettings() {
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-4 border-b border-gray-900/10 py-5 md:grid-cols-4">
      <SettingsRowHeader
        title="Permissions"
        description="Permissions for members of the organization."
      />

      <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 md:col-span-3">
        <div>
          <ContextFormFieldCheckbox
            label="Allow drivers to cancel trips"
            fieldPath="can_associate_cancel_trips"
          />
        </div>
        <div>
          <ContextFormFieldCheckbox
            label="Allow drivers to activate will-call trips"
            fieldPath="can_associate_activate_will_call_trips"
          />
        </div>
        <div>
          <ContextFormFieldCheckbox
            label="Allow drivers to view passenger phone numbers"
            fieldPath="can_associate_view_passenger_phone_number"
          />
        </div>
      </div>
    </div>
  );
}
